import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import * as Styles from './GradientButton.styles';

const GradientButton = ({
  onClick = () => null,
  testId = 'gradient-button',
  label = '',
  iconLeft = null,
  variant = 'primary',
  width = 'fit',
  size = 'lg',
}) => {
  const gradientRef = React.useRef(null);

  const handleMouseEffects = () => {
    const button = gradientRef.current;
    if (!button) return;

    const handleMouseMove = (e) => {
      const rect = button.getBoundingClientRect();
      const x = (e.clientX - rect.left) * 100 / button.clientWidth;
      const y = (e.clientY - rect.top) * 100 / button.clientHeight;
      button.style.setProperty('--mouse-x', x);
      button.style.setProperty('--mouse-y', y);
    };

    const handleMouseOut = () => {
      button.style.setProperty('--mouse-x', 0);
      button.style.setProperty('--mouse-y', 50);
    };

    button.addEventListener('mousemove', handleMouseMove);
    button.addEventListener('mouseout', handleMouseOut);

    return () => {
      button.removeEventListener('mousemove', handleMouseMove);
      button.removeEventListener('mouseout', handleMouseOut);
    };
  };

  const handleClick = () => {
    onClick && onClick();
  };

  useEffect(() => {
    handleMouseEffects();
  }, []);

  if (variant === 'primary') {
    return (
      <Styles.PrimaryButton
        type="button"
        data-testid={testId}
        onClick={handleClick}
        variant={variant}
        ref={gradientRef}
        $width={width}
        $size={size}
      >
        {iconLeft}
        <Styles.PrimaryLabel $size={size}>{label}</Styles.PrimaryLabel>
      </Styles.PrimaryButton>
    );
  }

  if (variant === 'secondary') {
    return (
      <Styles.SecondaryButton
        type="button"
        data-testid={testId}
        onClick={onClick}
        variant={variant}
        $width={width}
        $size={size}
      >
        {iconLeft}
        <Styles.SecondaryLabel
          ref={gradientRef}
          $size={size}
        >
          {label}
        </Styles.SecondaryLabel>
      </Styles.SecondaryButton>
    );
  }
};

GradientButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  testId: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  iconLeft: PropTypes.node,
  variant: PropTypes.string,
  width: PropTypes.string,
};

export default GradientButton;
